import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductMeasurementType from '../../models/ProductMeasurementType'

export interface ProductMeasurementTypeListState extends PaginatedApiState {
  productMeasurementTypes?: ProductMeasurementType[] 
}

const ProductMeasurementTypeList = (state: ProductMeasurementTypeListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductMeasurementTypeListState>('PRODUCTMEASUREMENTTYPE_LIST')(state, action)
  }
}

export default ProductMeasurementTypeList
